// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EA-z","modalContent":"FA-z","header":"GA-z","close":"HA-z"};